(function () {
  'use strict';

  var aliasGroups = [
    ['Yorkshire Terrier', 'Yorkie'],
    ['West Highland White Terrier', 'Westie'],
    ['Staffordshire Bull Terrier', 'Staffy', 'Staffie'],
    ['American Staffordshire Terrier', 'AmStaff'],
    ['Australian Cattle Dog', 'Blue Heeler'],
    ['Petit Basset Griffon Vendéen', 'PBGV'],
    ['Dogue de Bordeaux', 'French Mastiff'],
    ['English Bulldog', 'Bulldog'],
    ['French Bulldog', 'Frenchie'],
    ['Husky - Siberian', 'Siberian Husky'],
    ['Labrador Retriever', 'Labrador', 'Lab'],
    ['Dachshund - longhair', 'Long Haired Dachshund', 'Sausage Dog', 'Doxie'],
    ['Dachshund - smooth coat', 'Short Haired Dachshund', 'Sausage Dog', 'Doxie'],
    ['Dachshund - wirehaired', 'Wire Haired Dachshund', 'Sausage Dog', 'Doxie'],
    ['German Shepherd - long coat', 'Long Haired German Shepherd', 'GSD'],
    ['German Shepherd - standard coat', 'German Shepherd', 'GSD']
  ];

  function normalize(value) {
    return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function aliasesFor(value) {
    var aliases = [];
    aliasGroups.forEach(function (group) {
      if (group.indexOf(value) !== -1) aliases = aliases.concat(group);
    });
    return aliases;
  }

  function distance(a, b) {
    if (Math.abs(a.length - b.length) > 2) return 3;
    var row = Array.from({ length: b.length + 1 }, function (_, i) { return i; });
    for (var i = 1; i <= a.length; i += 1) {
      var previous = row[0];
      row[0] = i;
      for (var j = 1; j <= b.length; j += 1) {
        var old = row[j];
        row[j] = Math.min(row[j] + 1, row[j - 1] + 1, previous + (a[i - 1] === b[j - 1] ? 0 : 1));
        previous = old;
      }
    }
    return row[b.length];
  }

  function termScore(term, query) {
    if (term === query) return 0;
    if (term.startsWith(query)) return 10;
    var words = term.split(' ');
    if (words.some(function (word) { return word.startsWith(query); })) return 20;
    if (term.includes(query)) return 30;
    var tokens = query.split(' ');
    if (tokens.every(function (token) { return words.some(function (word) { return word.startsWith(token); }); })) return 40;
    if (query.length < 4) return Infinity;
    var total = 0;
    for (var i = 0; i < tokens.length; i += 1) {
      var token = tokens[i];
      if (words.some(function (word) { return word.startsWith(token); })) continue;
      if (token.length < 4) return Infinity;
      var best = Math.min.apply(null, words.map(function (word) { return distance(token, word); }));
      if (best > (token.length < 6 ? 1 : 2)) return Infinity;
      total += best;
    }
    return 80 + total;
  }

  function rankBreeds(records, value) {
    var query = normalize(value);
    return records.map(function (record) {
      var score = query ? termScore(normalize(record.value), query) : 0;
      if (query) aliasesFor(record.value).forEach(function (alias) {
        score = Math.min(score, termScore(normalize(alias), query) + 5);
      });
      return { record: record, score: score };
    }).filter(function (item) { return Number.isFinite(item.score); }).sort(function (a, b) {
      return a.score - b.score || a.record.value.localeCompare(b.record.value, 'en', { sensitivity: 'base' });
    });
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { normalize: normalize, rankBreeds: rankBreeds };
    return;
  }
  if (window.__soulyshineBreedPickerInstalled) return;
  var config = window.SoulyshineBreedPickerConfig || window.SoulyshineStandingDogMap;
  if (!config) return;
  var nativeMode = config.variantMode === 'native';
  if (nativeMode ? config.handle !== '200-dog-breeds-color-charm' : (!config.images || config.handle !== 'uniquely-them-essential-form-standing-dog')) return;
  if (!window.HTMLDialogElement || !HTMLDialogElement.prototype.showModal) return;
  window.__soulyshineBreedPickerInstalled = true;
  document.documentElement.setAttribute('data-soulyshine-breed-picker-instance', Date.now().toString(36));

  var pickerSelector = nativeMode ? 'variant-selects' : '[data-high-variant-picker="true"]';
  var selector = pickerSelector + ' .product-form__input--option-choose-breed select';
  var mounts = new WeakMap();
  var current = null;
  var records = [];
  var visible = [];
  var mode = 'search';
  var letter = '';
  var showAll = false;
  var activeIndex = -1;
  var pending = null;
  var queued = false;
  var focusAfterUpdate = false;
  var uid = 0;

  function node(tag, className, text) {
    var el = document.createElement(tag);
    if (className) el.className = className;
    if (text !== undefined) el.textContent = text;
    if (tag === 'button') el.type = 'button';
    return el;
  }

  function latestSelect(sectionId) {
    var section = document.getElementById('MainProduct-' + sectionId);
    return section && section.querySelector(selector);
  }

  function imageUrl(breed, select) {
    if (nativeMode) {
      var option = select && Array.from(select.options).find(function (item) { return item.value === breed; });
      var mediaId = option && option.getAttribute('data-media-id');
      var section = select && select.closest('[id^="MainProduct-"]');
      if (!mediaId || !/^\d+$/.test(mediaId) || !section) return '';
      var image = section.querySelector('[data-target$="-' + mediaId + '"] img');
      if (!image || !image.getAttribute('src')) return '';
      var nativeUrl = new URL(image.getAttribute('src'), location.origin);
      nativeUrl.searchParams.set('width', '112');
      return nativeUrl.toString();
    }
    var pair = config.images[breed];
    if (!pair) return '';
    var picker = select && select.closest(pickerSelector);
    var material = picker && picker.querySelector('.product-form__input--option-material input:checked');
    var silver = !material || (config.silverMaterials || []).indexOf(material.value) !== -1;
    var url = silver ? pair.silver : pair.gold;
    if (!url) return '';
    var parsed = new URL(url, location.origin);
    parsed.searchParams.set('width', '112');
    return parsed.toString();
  }

  function thumbnail(breed, select) {
    var img = node('img', 'ss-breed-image');
    img.alt = '';
    img.width = 48;
    img.height = 48;
    img.loading = 'lazy';
    var src = imageUrl(breed, select);
    if (src) img.src = src;
    else img.hidden = true;
    return img;
  }

  var dialog = node('dialog', 'ss-breed-dialog');
  dialog.id = 'ss-breed-dialog';
  dialog.setAttribute('aria-labelledby', 'ss-breed-dialog-title');
  var header = node('div', 'ss-breed-header');
  var heading = node('h2', '', 'Choose your breed');
  heading.id = 'ss-breed-dialog-title';
  var closeButton = node('button', 'ss-breed-close', '×');
  closeButton.setAttribute('aria-label', 'Close breed picker');
  header.append(heading, closeButton);
  var searchBox = node('div', 'ss-breed-search');
  var searchIcon = node('span', 'ss-breed-search-icon', '⌕');
  searchIcon.setAttribute('aria-hidden', 'true');
  var input = node('input', 'ss-breed-search-input');
  input.type = 'text';
  input.placeholder = "Search your dog's breed…";
  input.maxLength = 80;
  input.setAttribute('aria-label', 'Search all breeds');
  input.setAttribute('role', 'combobox');
  input.setAttribute('aria-autocomplete', 'list');
  input.setAttribute('aria-expanded', 'true');
  input.setAttribute('aria-controls', 'ss-breed-results');
  input.setAttribute('autocomplete', 'off');
  input.setAttribute('autocapitalize', 'none');
  input.setAttribute('spellcheck', 'false');
  input.setAttribute('enterkeyhint', 'done');
  var clearButton = node('button', 'ss-breed-clear', '×');
  clearButton.setAttribute('aria-label', 'Clear breed search');
  clearButton.hidden = true;
  searchBox.append(searchIcon, input, clearButton);
  var tabs = node('div', 'ss-breed-tabs');
  tabs.setAttribute('role', 'tablist');
  tabs.setAttribute('aria-label', 'Find a breed by');
  var searchTab = node('button', '', 'Search');
  var alphabetTab = node('button', '', 'Browse A–Z');
  [searchTab, alphabetTab].forEach(function (tab, index) {
    tab.setAttribute('role', 'tab');
    tab.id = 'ss-breed-tab-' + index;
    tab.setAttribute('aria-controls', 'ss-breed-panel');
  });
  tabs.append(searchTab, alphabetTab);
  var panel = node('div', 'ss-breed-panel');
  panel.id = 'ss-breed-panel';
  panel.setAttribute('role', 'tabpanel');
  var alphabet = node('div', 'ss-breed-alphabet');
  alphabet.setAttribute('role', 'group');
  alphabet.setAttribute('aria-label', 'First letter of breed name');
  var count = node('p', 'ss-breed-count');
  count.id = 'ss-breed-count';
  count.setAttribute('role', 'status');
  count.setAttribute('aria-live', 'polite');
  input.setAttribute('aria-describedby', count.id);
  var countRow = node('div', 'ss-breed-count-row');
  var changeLetter = node('button', 'ss-breed-change-letter', 'Change letter');
  changeLetter.hidden = true;
  changeLetter.addEventListener('click', function () {
    var previousLetter = letter;
    letter = ''; render();
    Array.from(alphabet.children).some(function (button) {
      if (button.textContent !== previousLetter) return false;
      button.focus({ preventScroll: true }); return true;
    });
  });
  countRow.append(count, changeLetter);
  var list = node('div', 'ss-breed-results');
  list.id = 'ss-breed-results';
  list.setAttribute('role', 'listbox');
  list.setAttribute('aria-label', 'Matching breeds');
  list.tabIndex = 0;
  var empty = node('div', 'ss-breed-empty');
  var moreButton = node('button', 'ss-breed-more');
  var scroll = node('div', 'ss-breed-scroll');
  scroll.append(list, empty, moreButton);
  panel.append(alphabet, countRow, scroll);
  dialog.append(header, searchBox, tabs, panel);

  function position() {
    if (!dialog.open || !current) return;
    var viewport = window.visualViewport;
    var top = viewport ? viewport.offsetTop : 0;
    var height = viewport ? viewport.height : innerHeight;
    if (matchMedia('(max-width: 749px)').matches) {
      var gap = Math.min(52, height * 0.06);
      dialog.style.top = (top + gap) + 'px';
      dialog.style.left = '0px';
      dialog.style.width = '100%';
      dialog.style.height = Math.max(220, height - gap) + 'px';
      dialog.style.maxHeight = Math.max(220, height - gap) + 'px';
    } else {
      var rect = current.trigger.getBoundingClientRect();
      var width = Math.min(460, innerWidth - 32);
      var availableBelow = height - rect.bottom - 16;
      var panelTop = availableBelow >= 340 ? rect.bottom + 8 : Math.max(16, Math.min(rect.top, height - 620));
      dialog.style.left = Math.max(16, Math.min(rect.left, innerWidth - width - 16)) + 'px';
      dialog.style.top = panelTop + 'px';
      dialog.style.width = width + 'px';
      dialog.style.height = Math.min(620, height - panelTop - 16) + 'px';
      dialog.style.maxHeight = dialog.style.height;
    }
  }

  function setMode(next, focus) {
    mode = next;
    showAll = false;
    letter = '';
    input.value = '';
    if (mode === 'alphabet') input.blur();
    render();
    if (focus) (mode === 'search' ? input : alphabetTab).focus({ preventScroll: true });
    position();
  }

  function render() {
    activeIndex = -1;
    input.removeAttribute('aria-activedescendant');
    list.removeAttribute('aria-activedescendant');
    clearButton.hidden = !input.value;
    searchTab.setAttribute('aria-selected', String(mode === 'search'));
    alphabetTab.setAttribute('aria-selected', String(mode === 'alphabet'));
    searchTab.tabIndex = mode === 'search' ? 0 : -1;
    alphabetTab.tabIndex = mode === 'alphabet' ? 0 : -1;
    panel.setAttribute('aria-labelledby', mode === 'search' ? searchTab.id : alphabetTab.id);
    alphabet.hidden = mode !== 'alphabet' || !!letter;
    changeLetter.hidden = mode !== 'alphabet' || !letter;
    var matches;
    var near = false;
    if (mode === 'alphabet') {
      matches = letter ? records.filter(function (record) { return normalize(record.value).startsWith(letter.toLowerCase()); }) : [];
      count.textContent = letter ? letter + ' · ' + matches.length + (matches.length === 1 ? ' breed' : ' breeds') : 'Choose a letter to browse ' + records.length + ' breeds';
      alphabet.querySelectorAll('button').forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.textContent === letter));
      });
    } else {
      var ranked = rankBreeds(records, input.value);
      matches = ranked.map(function (item) { return item.record; });
      near = !!ranked.length && ranked[0].score >= 80;
      count.textContent = input.value
        ? (near ? 'Closest matches · ' : '') + matches.length + (matches.length === 1 ? ' matching breed' : ' matching breeds')
        : records.length + ' breeds · type a name to narrow the list';
    }
    visible = mode === 'search' && !showAll ? matches.slice(0, 6) : matches;
    list.replaceChildren();
    var fragment = document.createDocumentFragment();
    var select = current && latestSelect(current.sectionId);
    visible.forEach(function (record, index) {
      var option = node('div', 'ss-breed-option');
      option.id = 'ss-breed-result-' + index;
      option.dataset.index = String(index);
      option.setAttribute('role', 'option');
      option.setAttribute('aria-selected', String(!!select && select.value === record.value));
      option.setAttribute('aria-label', record.value + (record.disabled ? ' — unavailable with selected material' : ''));
      if (record.disabled) option.setAttribute('aria-disabled', 'true');
      var copy = node('span', 'ss-breed-option-copy');
      var split = record.value.split(' - ');
      copy.appendChild(node('span', 'ss-breed-option-name', split[0]));
      if (split.length > 1) copy.appendChild(node('span', 'ss-breed-option-detail', split.slice(1).join(' - ')));
      if (record.disabled) copy.appendChild(node('span', 'ss-breed-option-detail', 'Unavailable with selected material'));
      var mark = node('span', 'ss-breed-option-mark', select && select.value === record.value ? '✓' : '›');
      mark.setAttribute('aria-hidden', 'true');
      option.append(thumbnail(record.value, select), copy, mark);
      fragment.appendChild(option);
    });
    list.appendChild(fragment);
    empty.hidden = !!matches.length;
    empty.textContent = mode === 'alphabet' && !letter
      ? 'Tap a letter above to see its breeds.'
      : 'No breeds found. Try a shorter name or browse A–Z.';
    moreButton.hidden = mode !== 'search' || showAll || matches.length <= 6;
    moreButton.textContent = 'View all ' + matches.length + (input.value ? ' matches' : ' breeds');
    panel.scrollTop = 0;
  }

  function openPicker(mount, nextMode) {
    if (pending) return;
    var select = latestSelect(mount.sectionId);
    if (!select || select.closest('[aria-busy="true"]')) return;
    current = mount;
    records = Array.from(select.options).map(function (option) {
      return { value: option.value, disabled: option.disabled || option.classList.contains('non-existent') };
    }).filter(function (record) { return !!record.value; });
    alphabet.replaceChildren();
    'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').forEach(function (letterValue) {
      var button = node('button', '', letterValue);
      var quantity = records.filter(function (record) { return normalize(record.value).startsWith(letterValue.toLowerCase()); }).length;
      button.disabled = quantity === 0;
      button.setAttribute('aria-label', letterValue + ', ' + quantity + (quantity === 1 ? ' breed' : ' breeds'));
      button.setAttribute('aria-pressed', 'false');
      button.addEventListener('click', function () { letter = letterValue; render(); list.focus({ preventScroll: true }); });
      alphabet.appendChild(button);
    });
    setMode(nextMode, false);
    mount.trigger.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('ss-breed-open');
    // showModal restores focus to the appropriate element; no query is committed here.
    input.autofocus = nextMode === 'search';
    alphabetTab.autofocus = nextMode === 'alphabet';
    dialog.showModal();
    position();
    (nextMode === 'search' ? input : alphabetTab).focus({ preventScroll: true });
  }

  function closePicker() {
    if (!dialog.open) return;
    input.blur();
    dialog.close();
    document.documentElement.classList.remove('ss-breed-open');
    if (current) {
      current.trigger.setAttribute('aria-expanded', 'false');
      var select = latestSelect(current.sectionId);
      var mount = select && mounts.get(select);
      if (mount) mount.trigger.focus({ preventScroll: true });
    }
  }

  function selectRecord(record) {
    if (!record || record.disabled || !current || pending) return;
    var select = latestSelect(current.sectionId);
    if (!select) return;
    var previous = select.value;
    closePicker();
    if (previous === record.value) return;
    if (nativeMode) {
      // Keep Shopify's standard variant/media and cart behavior intact.
      select.value = record.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      refreshMount(current);
      current.trigger.focus({ preventScroll: true });
      return;
    }
    var section = document.getElementById('MainProduct-' + current.sectionId);
    section.removeAttribute('data-variant-error');
    pending = { sectionId: current.sectionId, previous: previous, value: record.value, buttons: [] };
    section.querySelectorAll('button[name="add"], .product-form__submit').forEach(function (button) {
      pending.buttons.push({ button: button, disabled: button.disabled });
      button.disabled = true;
    });
    current.trigger.disabled = true;
    current.browse.disabled = true;
    current.status.textContent = 'Updating your breed…';
    focusAfterUpdate = true;
    select.value = record.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function refreshMount(mount) {
    var select = mount.select;
    var name = select.value || 'Search or select your breed…';
    mount.trigger.querySelector('.ss-breed-trigger-name').textContent = name;
    mount.trigger.setAttribute('aria-label', (select.value ? 'Selected breed: ' + select.value + '. ' : '') + 'Search or change breed');
    var img = mount.trigger.querySelector('img');
    var src = imageUrl(select.value, select);
    img.hidden = !src;
    if (src && img.getAttribute('src') !== src) img.src = src;
  }

  function mountSelect(select) {
    var existing = mounts.get(select);
    if (existing) {
      if (nativeMode) refreshMount(existing);
      return existing;
    }
    var picker = select.closest(pickerSelector);
    if (nativeMode && picker && picker.dataset.url !== config.productUrl) return null;
    var wrapper = select.closest('.product-form__input--option-choose-breed');
    var native = select.closest('.select');
    if (!picker || !wrapper || !native) return null;
    var block = node('div', 'ss-breed-picker');
    var trigger = node('button', 'ss-breed-trigger');
    trigger.id = 'ss-breed-trigger-' + (++uid);
    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.setAttribute('aria-controls', dialog.id);
    trigger.setAttribute('aria-expanded', 'false');
    var text = node('span', 'ss-breed-trigger-copy');
    text.append(node('span', 'ss-breed-trigger-name', select.value || 'Search or select your breed…'), node('span', 'ss-breed-trigger-hint', 'Search or change breed'));
    var icon = node('span', 'ss-breed-trigger-arrow', '⌕');
    icon.setAttribute('aria-hidden', 'true');
    trigger.append(thumbnail(select.value, select), text, icon);
    trigger.setAttribute('aria-label', (select.value ? 'Selected breed: ' + select.value + '. ' : '') + 'Search or change breed');
    var browse = node('button', 'ss-breed-browse', 'Browse A–Z');
    var status = node('span', 'ss-breed-status');
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    block.append(trigger, browse, status);
    var mount = { select: select, sectionId: picker.dataset.section, trigger: trigger, browse: browse, status: status };
    trigger.addEventListener('click', function () { openPicker(mount, 'search'); });
    browse.addEventListener('click', function () { openPicker(mount, 'alphabet'); });
    native.insertAdjacentElement('afterend', block);
    native.classList.add('ss-breed-native');
    var label = wrapper.querySelector('label.form__label');
    if (label) label.htmlFor = trigger.id;
    mounts.set(select, mount);
    return mount;
  }

  function sync() {
    document.querySelectorAll(selector).forEach(mountSelect);
    if (!pending) return;
    var section = document.getElementById('MainProduct-' + pending.sectionId);
    if (!section || section.getAttribute('data-variant-error') !== 'true') return;
    var select = latestSelect(pending.sectionId);
    if (select) select.value = pending.previous;
    pending.buttons.forEach(function (entry) { if (entry.button.isConnected) entry.button.disabled = entry.disabled; });
    var mount = select && mounts.get(select);
    if (mount) {
      mount.trigger.disabled = false;
      mount.browse.disabled = false;
      mount.status.textContent = 'Could not update your breed. Please try again.';
      mount.trigger.focus({ preventScroll: true });
    }
    pending = null;
    focusAfterUpdate = false;
  }

  function queueSync() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; sync(); });
  }

  closeButton.addEventListener('click', closePicker);
  dialog.addEventListener('cancel', function (event) { event.preventDefault(); closePicker(); });
  dialog.addEventListener('click', function (event) {
    var rect = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) closePicker();
  });
  searchTab.addEventListener('click', function () { setMode('search', true); });
  alphabetTab.addEventListener('click', function () { setMode('alphabet', true); });
  tabs.addEventListener('keydown', function (event) {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault(); setMode(mode === 'search' ? 'alphabet' : 'search', false);
      (mode === 'search' ? searchTab : alphabetTab).focus();
    }
  });
  input.addEventListener('input', function () {
    mode = 'search'; letter = ''; showAll = false; render();
  });
  clearButton.addEventListener('click', function () { input.value = ''; showAll = false; render(); input.focus(); });
  moreButton.addEventListener('click', function () { showAll = true; render(); input.blur(); list.focus({ preventScroll: true }); });
  list.addEventListener('mousedown', function (event) { event.preventDefault(); });
  list.addEventListener('click', function (event) {
    var option = event.target.closest('.ss-breed-option');
    if (option) selectRecord(visible[Number(option.dataset.index)]);
  });
  function navigateResults(event) {
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();
      if (!visible.length) return;
      activeIndex = event.key === 'ArrowDown' ? Math.min(visible.length - 1, activeIndex + 1) : (activeIndex <= 0 ? visible.length - 1 : activeIndex - 1);
      Array.from(list.children).forEach(function (el, index) { el.classList.toggle('ss-breed-option-active', index === activeIndex); });
      var active = list.children[activeIndex];
      input.setAttribute('aria-activedescendant', active.id);
      list.setAttribute('aria-activedescendant', active.id);
      active.scrollIntoView({ block: 'nearest' });
    } else if (event.key === 'Enter') {
      event.preventDefault();
      if (activeIndex >= 0) selectRecord(visible[activeIndex]);
    }
  }
  input.addEventListener('keydown', navigateResults);
  list.addEventListener('keydown', navigateResults);
  document.addEventListener('soulyshine:variant:updated', function (event) {
    var picker = event.detail && event.detail.picker;
    if (pending && picker && picker.dataset.section === pending.sectionId) {
      pending.buttons.forEach(function (entry) { if (entry.button.isConnected) entry.button.disabled = entry.disabled; });
      pending = null;
    }
    sync();
    if (focusAfterUpdate && picker) {
      var select = picker.querySelector('.product-form__input--option-choose-breed select');
      var mount = select && mounts.get(select);
      if (mount) mount.trigger.focus({ preventScroll: true });
      focusAfterUpdate = false;
    }
  });
  // Guard against stale-variant submissions while Shopify resolves a new breed.
  ['click', 'submit'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      if (!pending) return;
      var target = event.target.closest && event.target.closest('button[name="add"], .product-form__submit, form[action*="/cart/add"]');
      var section = target && target.closest('[id^="MainProduct-"]');
      if (section && section.id === 'MainProduct-' + pending.sectionId) { event.preventDefault(); event.stopImmediatePropagation(); }
    }, true);
  });
  window.addEventListener('resize', position);
  window.addEventListener('scroll', function () { if (dialog.open && innerWidth >= 750) position(); }, { passive: true });
  if (window.visualViewport) {
    visualViewport.addEventListener('resize', position);
    visualViewport.addEventListener('scroll', position);
  }
  document.addEventListener('shopify:section:load', queueSync);
  if (nativeMode) document.addEventListener('change', function (event) {
    if (event.target.matches && event.target.matches(selector)) queueSync();
  });
  function start() {
    document.body.appendChild(dialog);
    sync();
    new MutationObserver(function (mutations) {
      if (mutations.some(function (mutation) {
        return mutation.type === 'attributes' || Array.from(mutation.addedNodes).some(function (el) {
          return el.nodeType === 1 && (el.matches(pickerSelector + ', [id^="ProductInfo-"]') || el.querySelector(selector));
        });
      })) queueSync();
    }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-variant-error'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
